import {observer} from "mobx-react";
import {useStores} from "../../Hooks";
import React, {useEffect, useState} from "react";
import ConditionalComponent from "../Shared/ConditionalComponent";
import SurveyQuestion from "./SurveyQuestion";
import {Button} from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import Utility from "../../Utility";

const SurveyComponent = observer(() => {
    const {generalStore, rtcStore, modalStore, surveyStore} = useStores();

    useEffect(() => {
        if(surveyStore.currentSurvey.surveyType && surveyStore.currentQuestions.length === 0){
            surveyStore.getSurvey()
        }
    }, [surveyStore.currentSurvey]);
    return (
        <>
           <ConditionalComponent if={surveyStore.currentQuestions.length > 0}>
               <div className="flex flex-col bg-background-bormal justify-start items-start gap-y-6 text-main-normal font-sans mx-auto pb-20" style={{width: '100%', maxWidth: '1000px'}}>
                   <div className="flex flex-row justify-end items-center" style={{width: '100%'}}>
                       {surveyStore.isModal && !Utility.isMobile() &&<CloseIcon  sx={{ color: 'var(--main-normal-color)',  fontSize:'16px', cursor: 'pointer'}} onClick={surveyStore.skipSurvey} />}
                   </div>
                   <div className="flex flex-col justify-start items-start gap-y-3">
                       <div class="capitalize font-bold break-words text-2xl">{generalStore.translate('CompleteYourFeedback')}</div>
                       <div className="text-sm font-normal break-words">{generalStore.translate('PleaseAnswerAllQuestionsAboutYourRecent')} {surveyStore.currentSurvey.surveyName}</div>
                   </div>
                   {surveyStore.currentQuestions.map((question, index) =>
                       <SurveyQuestion question={question} index={index}/>
                   )}
                   <div className={`flex flex-row items-center ${Utility.isMobile() && surveyStore.isModal ? 'fixed bottom-0 left-0 right-0 p-4 bg-background-normal z-50 justify-between' : 'h-100 justify-end'}`} style={{width: '100%'}}>
                       {Utility.isMobile() && surveyStore.isModal && (
                           <Button
                               onClick={surveyStore.skipSurvey}
                               sx={{
                                   height: 35,
                                   px: 0,
                                   textTransform: 'none',
                                   borderRadius: '25px',
                                   backgroundColor: 'transparent',
                                   color: 'var(--leavedeletenew-normal-color)',
                                   fontSize: 14,
                                   fontWeight: 400,
                                   lineHeight: '21px',
                                   fontFamily: 'Open Sans, sans-serif',
                                   display: 'flex',
                                   alignItems: 'center',
                                   justifyContent: 'center',
                                   gap: 4,
                               }}
                           >{generalStore.translate('CloseWithoutSubmitting')}
                           </Button>
                       )
                       }
                       <Button
                           disabled={!surveyStore.validateSurveyAnswers}
                           onClick={surveyStore.submitSurvey}
                           sx={{
                               height: 35,
                               px: 3,
                               textTransform: 'none',
                               borderRadius: '25px',
                               backgroundColor: 'var(--classicbutton-normal-color)',
                               color: 'var(--classicbutton-normal-text-color)',
                               fontSize: 14,
                               fontWeight: 400,
                               lineHeight: '21px',
                               fontFamily: 'Open Sans, sans-serif',
                               display: 'flex',
                               alignItems: 'center',
                               justifyContent: 'center',
                               gap: 4,
                               '&:hover': {
                                   backgroundColor: 'var(--classicbutton-hovered-color)',
                               },
                               '&.Mui-disabled': {
                                   backgroundColor: 'var(--classicbutton-disabled-color)',
                                   cursor: 'not-allowed',
                                   color: 'var(--classicbutton-normal-text-color)',
                               },
                           }}
                           >
                           {generalStore.translate('SubmitSurvey')}
                    </Button>
                   </div>
               </div>

           </ConditionalComponent>
        </>
    );
});

export default SurveyComponent;
